<template>

  <div>
    <div v-if="searched">
      <base-button
        v-if="loading === false"
        tag="a"
        class="bg-blue w-25 text-center mb-4 ml-auto d-block text-white"
        type="button"
        @click="reset"
        :icon="{ prefix: 'fas', iconName: 'search'}">
        Search Again?
      </base-button>
      <div v-if="loading === false">
        <flickr-masonry :photos="photographs" v-if="photographs.length > 1"></flickr-masonry>
        <div v-else class="text-center mt-5 mb-10">
                                    <span class="d-block text-warning generic-error-icon">
                                    <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'exclamation-triangle' }"/>
                                    </span>
          <span class="generic-error-text">No data available based on these parameters</span>
        </div>
      </div>
      <ptwist-loading v-else></ptwist-loading>

    </div>
    <tabs v-else fill class="flex-column flex-md-row">
      <!--<base-switch class="mt-3" v-model="longSearch"></base-switch> Enable Long Search-->
      <card shadow>
        <tab-pane class="flickr-tab">
          <span slot="title">
              <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'hashtag' }"/> Select one of the top hashtags
          </span>
          <h5 class="text-center card p-3" v-if="!hashtagsProgress"> Select on of the following #hashtags to
            search on Flickr!</h5>
          <ptwist-loading v-if="loading"></ptwist-loading>
          <div v-else>
            <base-progress v-if="hashtagsProgress" type="primary"
                           :value="progress"
                           label="Generating Wordcloud"></base-progress>
            <vue-word-cloud
              class="wordcloud"
              v-on:update:progress="hashtagsProgress = $event"
              :words="topHashtags"
              :color="color"
              font-family="Roboto">
              <template slot-scope="{text, weight, word}">
                <div class="wordcloud-word" style="cursor: pointer;"
                     @click="onHashtagClick(word)">
                  {{ text }}
                </div>
              </template>
            </vue-word-cloud>
          </div>

        </tab-pane>
        <tab-pane>
                <span slot="title" class="flickr-tab">
                    <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'palette' }"/> Create your own sentence
                </span>
          <h5 class="text-center card p-3" v-if="!termsProgress">Click on any word from the wordcloud to
            create a custom sentence!</h5>
          <base-button class="mt-1" :key="index" v-for="(word,index) in wordsSelected"
                       @click="removeWord(index)"
                       type="primary">
            <span>{{word}}</span>
            <badge type="white">X</badge>
          </base-button>
          <base-button
            v-if="wordsSelected.length > 0"
            tag="a"
            class="bg-blue w-25 mt-3 text-center d-block
                            text-white ml-auto mr-auto"
            type="button"
            @click="submitCustomSentence()"
            :icon="{ prefix: 'fas', iconName: 'search'}">
            Search
          </base-button>
          <ptwist-loading v-if="loading"></ptwist-loading>
          <vue-word-cloud
            v-else
            class="wordcloud"
            :words="topTerms"
            :color="color"
            font-family="Roboto">
            <template slot-scope="{text, weight, word}">
              <div class="wordcloud-word" style="cursor: pointer;"
                   @click="onTermClick(word)">
                {{ text }}
              </div>
            </template>
          </vue-word-cloud>
        </tab-pane>
      </card>
    </tabs>
  </div>
</template>
<script>
import { getRandomArrayIndex, convertRange } from '../utils'
import { Bus } from '../bus'
import Tabs from '@/components/Tabs/Tabs.vue'
import TabPane from '@/components/Tabs/TabPane.vue'
import FlickrMasonry from '@/components/FlickrMasonry.vue'

export default {
  name: 'flickr-repository',
  components: {
    TabPane,
    Tabs,
    FlickrMasonry
  },
  data () {
    return {
      loading: true,
      hashtagsProgress: { completedWords: 0, totalWords: 50 },
      termsProgress: { completedWords: 0, totalWords: 80 },
      wordcloudReady: true,
      topHashtags: [],
      topTerms: [],
      keyword: '',
      wordsSelected: [],
      photographs: [],
      searched: false,
      longSearch: false
    }
  },
  computed: {
    progress: function () {
      return parseInt(convertRange(this.hashtagsProgress.completedWords, [0, 50], [0, 100]))
    },
    progressTerms: function () {
      return parseInt(convertRange(this.termsProgress.completedWords, [0, 80], [0, 100]))
    },
    color: function () {
      const colors = ['#179e81', '#ffc107', '#114B5F', '#88D498', '#C6DABF']
      return function () {
        return getRandomArrayIndex(colors)
      }
    }
  },
  mounted () {
    this.update()
  },
  created () {
    Bus.$on('tab-changed', function (tabIndex) {
      let method = null
      tabIndex === 0 ? method = 'hashcloud' : method = 'custom'
      this.update(method)
    }.bind(this))
    Bus.$on('input', function (text) {
      this.keyword = text
    }.bind(this))
  },
  methods: {
    update (method) {
      this.loading = true
      if (method === 'hashcloud') {
        this.wordcloudReady = false
        let payload = {
          data: {},
          endpoint: 'twitter/top-hashtags'
        }
        this.$store
          .dispatch('api/get', payload)
          .then(response => {
            this.topHashtags = this.scaleWords(response.data)
            this.loading = false
          })
      } else {
        this.wordcloudReady = false
        let payload = {
          data: {},
          endpoint: 'twitter/top-terms'
        }
        this.$store
          .dispatch('api/get', payload)
          .then(response => {
            this.topTerms = this.scaleWords(response.data)
            this.loading = false
          })
      }
    },
    removeWord (index) {
      this.wordsSelected.splice(index, 1)
    },
    onHashtagClick (word) {
      this.keyword = word[0]
      this.search()
    },
    onTermClick (word) {
      if (this.wordsSelected.length < 10 && !this.wordsSelected.includes(word[0])) {
        this.wordsSelected.push(word[0])
      }
    },
    scaleWords (hashtags) {
      const hashtagsMax = hashtags[0][1]
      const hashtagsMin = hashtags[hashtags.length - 1][1]
      hashtags = hashtags.map(term => {
        return [term[0], convertRange(term[1], [hashtagsMin, hashtagsMax], [2, 8])]
      })
      return hashtags
    },
    search () {
      this.loading = true
      this.searched = true
      let payload = {
        data: {
          keyword: this.removeSpaces(this.keyword)
        },
        endpoint: 'flickr/top-photos'
      }
      this.$store
        .dispatch('api/get', payload)
        .then(response => {
          this.photographs = response.data
          this.loading = false
        })
    },
    submitCustomSentence () {
      this.keyword = this.wordsSelected.join(' ')
      this.search()
    },
    reset () {
      this.searched = false
    },
    removeSpaces (str) {
      return str.replace(' ', ',')
    }

  }
}
</script>
<style>
  .flickr-tab .nav-link.active {
    background-color: #ff0084 !important
  }

  .wordcloud {
    width: 100%;
    height: 500px !important
  }

  .wordcloud-word:hover {
    text-shadow: 1px 1px 0 rgb(101, 101, 101)
  }
</style>
